import Cancel from './Cancel.js';
import React from 'react';
import GeneratedResponse from './GeneratedResponse.js';
import AgentAssistCard from './AgentAssistCard.js';
import Typography from '@mui/material/Typography';
// function renderConfidence(score) {
//   const pct = Number(score).toLocaleString(undefined, {
//     style: 'percent',
//     minimumFractionDigits: 0,
//   });
//   if (score > 0.92) {
//     return (
//       <Typography
//         sx={{
//           fontSize: '0.85rem',
//           lineHeight: 1.2,
//           textAlign: 'left',
//           ml: '8px',
//           color: 'highConfidence.main',
//         }}
//       >
//         {pct + ' Match'}
//       </Typography>
//     );
//   } else if (score > 0.8) {
//     return (
//       <Typography
//         sx={{
//           fontSize: '0.85rem',
//           lineHeight: 1.2,
//           textAlign: 'left',
//           ml: '8px',
//           color: 'mediumConfidence.main',
//         }}
//       >
//         {pct + ' Match'}
//       </Typography>
//     );
//   }
// }

function Recommendation({ recommendation, latestInbound, contacts }) {
  if (recommendation == null) {
    return null;
  }
  if (recommendation.type === 'action') {
    return (
      <AgentAssistCard>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '8px',
          }}
        >
          <Typography
            sx={{
              fontSize: '0.85rem',
              lineHeight: 1.2,
              textAlign: 'left',
            }}
          >
            <strong>Detected intent: </strong>
            {recommendation.data.intent}{' '}
          </Typography>
          {/* {renderConfidence(recommendation.data.confidence)} */}
        </div>
        <Cancel latestInbound={latestInbound} contacts={contacts} />
      </AgentAssistCard>
    );
  } else if (recommendation.type === 'generated') {
    return (
      <AgentAssistCard>
        <GeneratedResponse
          id={recommendation.data.generated_message_id}
          generated={recommendation.data.generated}
          containsAction={recommendation.data.contains_action}
          latestInbound={latestInbound}
          source="generated"
        />
      </AgentAssistCard>
    );
  }
  return (
    <AgentAssistCard>
      <Typography
        sx={{ fontSize: '0.85rem', lineHeight: 1.2, textAlign: 'left' }}
      >
        <span>This ticket is not eligible for automatic resolution.</span>
      </Typography>
    </AgentAssistCard>
  );
}

export default Recommendation;
